// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/home-scene/featured-big-carousel.scss
// module id = 97
// module chunks = 0